/**
 * This file is part of ONP.
 *
 * Copyright (c) 2014 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/designFacePreview/guideLines/view/abstractView'], function($, AbstractView) {
    return AbstractView.extend({
        arcSize: 12,

        renderBleedZone: function(options) {
            options = options || {};

            this.context.strokeStyle = this.bleedZoneColor;
            this._renderOffsetZone(0, 0, options);

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, 0, Math.round(height / 2) + 15);
            }
        },

        renderTrimZone: function(options) {
            options = options || {};
            var widthOffset = Math.round(this.getDeltaWidth(this.zones.trimWidth) / 2);
            var heightOffset = Math.round(this.getDeltaHeight(this.zones.trimHeight) / 2);

            this.context.strokeStyle = this.trimZoneColor;
            this._renderOffsetZone(widthOffset, heightOffset, options);

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, widthOffset, Math.round(height / 2));
            }
        },

        renderSafeZone: function(options) {
            options = options || {};
            var widthOffset = Math.round(this.getDeltaWidth(this.zones.safeWidth) / 2);
            var heightOffset = Math.round(this.getDeltaHeight(this.zones.safeHeight) / 2);

            this.context.strokeStyle = this.safeZoneColor;
            this._renderOffsetZone(widthOffset, heightOffset, options);

            if (options.legend && options.legend.text) {
                var height = this.model.get('isVertical') ? this.width : this.height;
                this._addLegend(options.legend, widthOffset, Math.round(height / 2) - 15);
            }
        },

        _renderOffsetZone: function(widthOffset, heightOffset, options) {
            this.context.beginPath();
            this.context.moveTo(widthOffset, heightOffset + this.arcSize);
            this.context.arcTo(widthOffset, heightOffset, widthOffset + this.arcSize, heightOffset, this.arcSize);
            this.context.lineTo(this.width - widthOffset - this.arcSize, heightOffset);
            this.context.arcTo(this.width - widthOffset, heightOffset, this.width - widthOffset, heightOffset + this.arcSize, this.arcSize);
            this.context.lineTo(this.width - widthOffset, this.height - heightOffset - this.arcSize);
            this.context.arcTo(
                this.width - widthOffset,
                this.height - heightOffset,
                this.width - widthOffset - this.arcSize,
                this.height - heightOffset,
                this.arcSize
            );
            this.context.lineTo(widthOffset + this.arcSize, this.height - heightOffset);
            this.context.arcTo(
                widthOffset,
                this.height - heightOffset,
                widthOffset,
                this.height - heightOffset - this.arcSize,
                this.arcSize
            );
            this.context.closePath();

            if (options.background) {
                this.context.fillStyle = options.background;
                this.context.fill();
                if (this.foldingType) {
                    this.textBackground = options.background;
                }
            }

            this.context.stroke();
        }
    });
});
